export default "__VITE_ASSET__D_C1n0VN__"